var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"direction"}},[_c('bread',{attrs:{"content":_vm.breadContent}}),_c('p',{staticClass:"Page-title"},[_vm._v("研究方向")]),_c('el-divider'),_c('p',{staticClass:"mes",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }